import React, { useEffect, useMemo, useState } from 'react'
import KapalService from '../../../../services/kapal/KapalService'
import Card from '../../../../components/Card'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import DisposisiKapal from '../../../../utilities/kapal/DisposisiKapal'
import { formatDateTimeLocalDate } from '../../../../utilities/Utils'
import { FaBook, FaEdit, FaEye, FaFile, FaFileAlt, FaFilePdf, FaPaperPlane, FaTasks } from 'react-icons/fa'
import ModalEvp from '../modal/ModalEvp'
import ModalSpt from '../modal/ModalSpt'
import ModalSt from '../modal/ModalSt'
import ModalBatalInspeksi from '../modal/ModalBatalInspeksi'
import ModalAuditKecukupan from '../modal/ModalAuditKecukupan'
import ModalInspeksi from '../modal/ModalInspeksi'
import ModalReviuRekom from '../modal/ModalReviuRekom'
import ModalTindakLanjutSt from '../modal/ModalTindakLanjutSt'
import ModalDataUmum from '../modal/ModalDataUmum'
import ModalInspeksiChecklist from '../modal/ModalInspeksiChecklist'
import ModalInspeksiChecklistHasil from '../modal/ModalInspeksiChecklistHasil'
import ModalRekom from '../modal/ModalRekom'

const ExpandableComponentKapal = ({ data, reloadList }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    const [listDisposisi, setListDisposisi] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getDisposisi = async () => {
            setLoading(true)
            try {
                const resPenugasan = await kapalService.listPenugasanAll(data.nomorAjuKapal)
                setListDisposisi(resPenugasan.data.data)
            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        }
        getDisposisi()
    }, [kapalService, data])
    return (
        <>
            <Card>
                <Card.Body>
                    {loading && <Spinner />}
                    <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                        <ul className="list-inline p-0 m-0 w-100">
                            {
                                listDisposisi.map((disp, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="timeline-dots timeline-dot1 border-danger text-primary"></div>
                                            <h6 className="float-left mb-1"><DisposisiKapal idDisposisi={disp.idDisposisi} /></h6>
                                            <small>Nomor : {disp.noTugas} / Tanggal : {disp.tglTugas !== null && formatDateTimeLocalDate(disp.tglTugas)}</small>
                                            <div className="d-inline-block w-100">
                                                <DisposisiProses dataPpmKapal={data} dataPenugasan={disp} reloadList={reloadList} />
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

const DisposisiProses = ({ dataPpmKapal, dataPenugasan, reloadList }) => {

    const [dataDisposisi, setDataDisposisi] = useState(null)
    const [isEdit, setIsEdit] = useState(false)

    const [showEvp, setShowEvp] = useState(false)
    const handleCloseEvp = () => {
        setShowEvp(false)
    }
    const [showSpt, setShowSpt] = useState(false)
    const handleCloseSpt = () => {
        setShowSpt(false)
    }
    const [showSt, setShowSt] = useState(false)
    const handleCloseSt = () => {
        setShowSt(false)
    }
    const [showBatalInspeksi, setShowBatalInspeksi] = useState(false)
    const handleCloseBatalInspeksi = () => {
        setShowBatalInspeksi(false)
    }
    const [showAudit, setShowAudit] = useState(false)
    const handleCloseAudit = () => {
        setShowAudit(false)
    }
    const [showInspeksi, setShowInspeksi] = useState(false)
    const handleCloseInspeksi = () => {
        setShowInspeksi(false)
    }
    const [showReviuRekom, setShowReviuRekom] = useState(false)
    const handleCloseReviuRekom = () => {
        setShowReviuRekom(false)
    }

    const handleShow = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        if (dataPenugasan.idDisposisi === 1) {
            //evp
            setShowEvp(true)
        } else if (dataPenugasan.idDisposisi === 9) {
            setShowSpt(true)
        } else if (dataPenugasan.idDisposisi === 2) {
            setShowSt(true)
        } else if (dataPenugasan.idDisposisi === 3) {
            setShowAudit(true)
        } else if (dataPenugasan.idDisposisi === 4) {
            setShowBatalInspeksi(true)
        } else if (dataPenugasan.idDisposisi === 5) {
            setShowInspeksi(true)
        } else if (dataPenugasan.idDisposisi === 7 || dataPenugasan.idDisposisi === 8) {
            setShowReviuRekom(true)
        }
    }

    const [showTlSt, setShowTlSt] = useState(false)
    const handleCloseTlST = () => {
        setShowTlSt(false)
    }
    const handleTindalLanjut = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowTlSt(true)
    }

    const [showDataUmum, setShowDataUmum] = useState(false)
    const handleCloseDataUmum = () => {
        setShowDataUmum(false)
    }
    const handleViewDataUmum = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowDataUmum(true)
    }

    const [showChecklist, setShowChecklist] = useState(false)
    const handleCloseChecklist = () => {
        setShowChecklist(false)
    }
    const handleViewChecklist = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowChecklist(true)
    }

    const [showHasilInspeksi, setShowHasilInspeksi] = useState(false)
    const handleCloseHasilInspeksi = () => {
        setShowHasilInspeksi(false)
    }
    const handleViewHasilInspeksi = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowHasilInspeksi(true)
    }

    const [showRekom, setShowRekom] = useState(false)
    const handleCloseRekom = () => setShowRekom(false)
    const handleViewRekom = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowRekom(true)
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-8">
                    {
                        ((localStorage.getItem("role") !== '4' && localStorage.getItem("role") !== '5' && localStorage.getItem("role") !== '8') && dataPenugasan.noTugas === null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Proses</Tooltip>
                            }>
                                <Button size="sm" variant="outline-primary" onClick={() => handleShow(dataPenugasan, true)}>
                                    <FaPaperPlane /> Proses
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        dataPenugasan.noTugas !== null &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat</Tooltip>
                            }>
                                <Button size="sm" variant="outline-info" onClick={() => handleShow(dataPenugasan, false)}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Preview PDF</Tooltip>
                            }>
                                <Button size="sm" variant="outline-warning">
                                    <FaFilePdf /> Preview PDF
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 2 && dataPenugasan.noTugas !== null && dataPpmKapal.kodeStatus === '022' &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Tindak Lanjut ST</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleTindalLanjut(dataPenugasan, true)}>
                                    <FaEdit /> Tindak Lanjut ST
                                </Button>
                            </OverlayTrigger>{' '}

                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 5 && dataPenugasan.noTugas !== null &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Data Umum Kapal</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleViewDataUmum(dataPenugasan, true)}>
                                    <FaFileAlt /> Data Umum Kapal
                                </Button>
                            </OverlayTrigger>{' '}
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Checklist Kapal</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleViewChecklist(dataPenugasan, true)}>
                                    <FaFile /> Data Checklist
                                </Button>
                            </OverlayTrigger>{' '}
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Hasil Inspeksi ke Pusat</Tooltip>
                            }>
                                <Button size="sm" variant="primary" onClick={() => handleViewHasilInspeksi(dataPenugasan, true)}>
                                    <FaBook /> Hasil Inspeksi
                                </Button>
                            </OverlayTrigger>
                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 7 && dataPenugasan.noTugas !== null &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Rekomendasi</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleViewRekom(dataPenugasan, true)}>
                                    <FaTasks /> Rekomendasi
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                </div>
            </div>
            <ModalEvp showEvp={showEvp} handleCloseEvp={handleCloseEvp} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalSpt showSpt={showSpt} handleCloseSpt={handleCloseSpt} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalSt showSt={showSt} handleCloseSt={handleCloseSt} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalBatalInspeksi showBatalInspeksi={showBatalInspeksi} handleCloseBatalInspeksi={handleCloseBatalInspeksi} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalAuditKecukupan showAudit={showAudit} handleCloseAudit={handleCloseAudit} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalInspeksi showInspeksi={showInspeksi} handleCloseInspeksi={handleCloseInspeksi} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalReviuRekom showReviuRekom={showReviuRekom} handleCloseReviuRekom={handleCloseReviuRekom} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalTindakLanjutSt showTlSt={showTlSt} handleCloseTlST={handleCloseTlST} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalDataUmum showDataUmum={showDataUmum} handleCloseDataUmum={handleCloseDataUmum} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalInspeksiChecklist showChecklist={showChecklist} handleCloseChecklist={handleCloseChecklist} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalInspeksiChecklistHasil showHasilInspeksi={showHasilInspeksi} handleCloseHasilInspeksi={handleCloseHasilInspeksi} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalRekom showRekom={showRekom} handleCloseRekom={handleCloseRekom} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit}/>
        </>
    )
}

export default ExpandableComponentKapal